import React, { useState, useEffect, useRef } from "react";
import {
    Input,
    Button,
    Form,
    Radio,
    Select,
    Checkbox,
    notification,
    Modal,
    Tag,
} from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import $axios from "../../services/axios";
import { formatNumberWithDots, checkRepayment, calculateTimeDifference } from "../../helpers/utils";
import { formatTime } from "../../helpers/formatDate";
import moment from "moment";
import dayjs from "dayjs";
import _ from "lodash";
import ConfirmModal from "../Common/ConfirmModal";
import RepaymentModal from "../../components/Common/RepaymentModal";

const { Option } = Select;

const DesktopStep3 = ({
    onChangeStep,
    onChangeBookingInfo,
    chooseFlight,
    setLoading,
    setStep,
    setChooseFlight,
    setFilterDay,
    setChoosingStep,
    tripType
}) => {
    const [modal, contextHolder] = Modal.useModal();
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const [isModalConfirm, setIsModalConfirm] = useState(false);
    const [form] = Form.useForm();
    const invoice = Form.useWatch("invoice", form);

    const [baggages, setBaggages] = useState([]);
    const [baggagesOut, setBaggagesOut] = useState([]);
    const [passengerIdChoose, setPassengerIdChoose] = useState(null);

    const [voucherValue, setVoucherValue] = useState(0);
    const [voucherCode, setVoucherCode] = useState("");
    const [voucherTxt, setVoucherTxt] = useState("");
    const [openVoucher, setOpenVoucher] = useState(false);
    const [vouchers, setVouchers] = useState([]);

    const FlightType = _.some(chooseFlight, f => !f.isdomestic) ? "international" : "domestic";
    const [bodyBooking, setBodyBooking] = useState(null);
    const [unpaidBookings, setUnpaidBookings] = useState([]);
    const [totalListPrice, setTotalListPrice] = useState({
        totalFixed: 0,
        baggage: 0,
        baggage_out: 0,
        totalDisplay: 0,
        totalpriceAdd: 0,
    });

    const [openRepaymentModal, setOpenRepaymentModal] = useState(false);
    const [dataRepayment, setDataRepayment] = useState(null);

    const departureDate = dayjs(chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startdate);

    const DOB_RANGE = {
        INF: {
            min: departureDate.clone().subtract(2, "year").add(1, "day"),
            max: departureDate.clone(),
        },
        CHD: {
            min: departureDate.clone().subtract(12, "year").add(1, "day"),
            max: departureDate.clone().subtract(2, "year"),
        },
    };

    const getMonths = () => _.range(1, 13).map((m) => String(m).padStart(2, "0"));
    const getDays = () => _.range(1, 32).map((d) => String(d).padStart(2, "0"));

    const getValidYearsByDayMonth = (type, day, month) => {
        if (!day || !month) return [];
        const { min, max } = DOB_RANGE[type];
        return _.range(min.year(), max.year() + 1).filter((year) => {
            const dob = dayjs(`${year}-${month}-${day}`, "YYYY-MM-DD", true);
            return dob.isBetween(min, max, "day", "[]");
        });
    };

    const validateAndResetYearIfInvalid = (p) => {
        const day = form.getFieldValue(`day_${p.id}`);
        const month = form.getFieldValue(`month_${p.id}`);
        const year = form.getFieldValue(`year_${p.id}`);
        if (!day || !month || !year) return;
        const validYears = getValidYearsByDayMonth(p.Type, day, month);
        if (!validYears.includes(year)) {
            form.setFieldsValue({ [`year_${p.id}`]: undefined });
        }
    };

    const fetchUnpaidOrder = async () => {
        const end = dayjs();
        const start = end.subtract(2, "day");
        try {
            const res = await $axios.$get(
                `/order-flight/findByAllUser?startdate=${start.format("DD/MM/YYYY")}&enddate=${end.format("DD/MM/YYYY")}&page=1&pageSize=100`
            );
            if (res?.data?.data?.data?.length > 0) {
                const bookings = res.data.data.data.filter(h => checkRepayment(h?.orderplanebookings[0]?.expirationdate, h?.orderplanebookings[0]?.timepurchase) && h?.paymentstatus === "PayLater");
                if (bookings.length > 0) setUnpaidBookings(bookings);
            }
        } catch (error) { }
    };

    // ----- TẠO LIST HÀNH KHÁCH -----
    const createPassengers = (type, count, prefix) => {
        return count > 0 ? _.range(1, count + 1).map((item) => ({
            id: `${prefix}-${item}`, FirstName: "", LastName: "", Type: type,
            Gender: "male", Birthday: "", ListBaggage: [], ListSeat: []
        })) : [];
    };

    const ListPassengerAdt = createPassengers("ADT", _.get(chooseFlight, "[0].adt", 0), "adt");
    const ListPassengerChd = createPassengers("CHD", _.get(chooseFlight, "[0].chd", 0), "chd");
    const ListPassengerInf = createPassengers("INF", _.get(chooseFlight, "[0].inf", 0), "inf");

    const ListPassenger = [...ListPassengerAdt, ...ListPassengerChd, ...ListPassengerInf].map((p, i) => ({ ...p, Index: i + 1 }));

    useEffect(() => {
        if (ListPassenger.length > 0) setPassengerIdChoose(ListPassenger[0].id);
        fetchUnpaidOrder();
    }, []);

    const initialValues = _.reduce(
        ListPassenger,
        (acc, num, index) => {
            acc[`gender_${num.id}`] = "male";
            if (index === 0) {
                acc[`surname_${num.id}`] = _.head(_.split(userInfo?.name, " "))?.normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/đ/g, "d")
                    .replace(/Đ/g, "D")
                    .toUpperCase();
                acc[`lastName_${num.id}`] = _.join(
                    _.tail(_.split(userInfo?.name, " ")),
                    " "
                )?.normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/đ/g, "d")
                    .replace(/Đ/g, "D")
                    .toUpperCase();
            }
            return acc;
        },
        {
            genderContact: "male",
            phone: userInfo?.phone,
            email: userInfo?.email,
            surnameContact: _.head(_.split(userInfo?.name, " "))
                ?.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/đ/g, "d")
                .replace(/Đ/g, "D")
                .toUpperCase(),
            lastNameContact: _.join(_.tail(_.split(userInfo?.name, " ")), " ")
                ?.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/đ/g, "d")
                .replace(/Đ/g, "D")
                .toUpperCase(),
        }
    );

    // ----- CÁC HÀM XỬ LÝ GET DỮ LIỆU LOGIC -----
    const getBaggage = async () => {
        setLoading(true);
        try {
            const resIn = await $axios.$post("/honghatrip/getbaggages", {
                System: chooseFlight[0]?.airline.code,
                Airline: chooseFlight[0]?.airline.code,
                flightvalue: chooseFlight?.[0]?.options?.[0]?.flights?.[0].flightvalue,
            });
            setBaggages(_.get(resIn, "data.data.baggages", []));

            if (chooseFlight.length === 2) {
                const resOut = await $axios.$post("/honghatrip/getbaggages", {
                    System: chooseFlight[1]?.airline.code,
                    Airline: chooseFlight[1]?.airline.code,
                    flightvalue: chooseFlight?.[1]?.options?.[0]?.flights?.[0].flightvalue,
                });
                setBaggagesOut(_.get(resOut, "data.data.baggages", []));
            }
        } catch (error) { } finally { setLoading(false); }
    };

    useEffect(() => {
        getBaggage();
        if (chooseFlight.length > 0) {
            const sumPrices = _.sum(_.map(chooseFlight, f => f.totalprice));
            const rootPrices = _.sum(_.map(chooseFlight, f => f.totalpriceroot));
            setTotalListPrice({
                totalFixed: sumPrices, baggage: 0, baggage_out: 0,
                totalDisplay: sumPrices, totalpriceAdd: sumPrices - rootPrices, totalOriginal: rootPrices,
            });
        }
    }, []);

    const getVouchers = async () => {
        setLoading(true);
        try {
            const res = await $axios.$post("/voucher/getVoucherByOrder", {
                Quantity: ListPassenger.length,
                Total: totalListPrice.totalFixed + totalListPrice.baggage + totalListPrice.baggage_out,
                TypeFight: FlightType,
            });
            const now = moment();
            setVouchers(res.data.data.filter(v => now.isBetween(moment(v.startdate), moment(v.enddate), null, "[]")));
        } catch (error) { } finally { setLoading(false); }
    };

    useEffect(() => {
        if (totalListPrice.totalFixed > 0) getVouchers();
    }, [totalListPrice.totalFixed]);

    const handleInputChange = (e, field) => {
        let inputValue = field.startsWith("surname_") || field === "surnameContact" ? e.target.value.split(" ")[0] : e.target.value;
        const uppercaseValue = inputValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toUpperCase();
        form.setFieldsValue({ [field]: uppercaseValue });
    };

    const handleChangeContactPersion = () => {
        form.setFieldsValue({
            surnameContact: form.getFieldValue(`surname_${passengerIdChoose}`),
            lastNameContact: form.getFieldValue(`lastName_${passengerIdChoose}`),
            genderContact: form.getFieldValue(`gender_${passengerIdChoose}`),
        });
    };

    const handleValuesFormChange = (changedValues, allValues) => {
        let totalBaggage = 0, totalBaggageOut = 0;
        ListPassenger.forEach((p) => {
            const bCodeIn = allValues[`baggage_${p.id}`];
            const bCodeOut = allValues[`baggage_out_${p.id}`];
            if (bCodeIn && bCodeIn !== -1) {
                totalBaggage += baggages.find((b) => b.code === bCodeIn)?.prices?.[0]?.price || 0;
            }
            if (bCodeOut && bCodeOut !== -1) {
                totalBaggageOut += baggagesOut.find((b) => b.code === bCodeOut)?.prices?.[0]?.price || 0;
            }
        });

        setTotalListPrice(prev => ({
            ...prev, baggage: totalBaggage, baggage_out: totalBaggageOut,
            totalDisplay: prev.totalFixed + totalBaggage + totalBaggageOut - voucherValue
        }));
    };

    // ----- XÁC THỰC VÀ PUSH DATA ĐẶT VÉ -----
    const verifyFlight = async () => {
        let dataVerify = { verifySession: [], flightvalues: [] };
        const requests = chooseFlight.map(async (flight) => {
            try {
                const res = await $axios.$post("/honghatrip/select", {
                    System: flight?.airline?.code, IsUpSell: false,
                    flightvalues: [flight?.options?.[0]?.flights?.[0].flightvalue],
                });
                if (res.data.statuscode === 200) {
                    if (_.some(res.data?.data?.faredatas, fare => _.some(fare.options[0].flights, f => _.some(f.segments, s => s.seatAvl === 0)))) {
                        throw new Error("Lỗi xác thực chuyến bay");
                    }
                    dataVerify.verifySession.push({ value: res.data.data.session || "", startpoint: flight?.options?.[0]?.flights?.[0].startpoint });
                    dataVerify.flightvalues.push({ value: res.data.data.faredatas?.[0]?.options?.[0]?.flights?.[0]?.flightValue || "", startpoint: flight?.options?.[0]?.flights?.[0].startpoint });
                }
            } catch (err) { throw new Error("Lỗi xác thực chuyến bay"); }
        });
        await Promise.all(requests);
        return dataVerify;
    };

    const getPassengers = (values, indexFlight) => {
        return ListPassenger.map((p, index) => {
            p.FirstName = values[`surname_${p.id}`]; p.LastName = values[`lastName_${p.id}`];
            p.Gender = values[`gender_${p.id}`] === "male";
            p.ListBaggage = indexFlight === 0 ? baggages.filter(b => b.code === values[`baggage_${p.id}`]) : baggagesOut.filter(b => b.code === values[`baggage_out_${p.id}`]);
            return {
                Index: index, SurName: p.FirstName, GivenName: p.LastName, Gender: p.Gender, Type: p.Type,
                Title: p.Type === "ADT" ? (p.Gender ? "MR" : "MS") : "MSTR",
                Baggages: p.ListBaggage.map((b) => b?.prices?.[0]?.value),
                DateOfBirth: p.Type === "ADT" ? "1990-01-01" : `${values[`year_${p.id}`]}-${values[`month_${p.id}`]}-${values[`day_${p.id}`]}`,
                Document: {
                    SurName: p.FirstName, GivenName: p.LastName, Gender: p.Gender,
                    DateOfBirth: p.Type === "ADT" ? "1990-01-01" : `${values[`year_${p.id}`]}-${values[`month_${p.id}`]}-${values[`day_${p.id}`]}`,
                    Number: "012345678900", Type: "I", National: "VNM", ExpiryDate: "2035-12-30", IssueCountry: "VNM", IssueDate: "2025-12-30",
                },
            };
        });
    };

    const getDuplicateBooking = (booking) => {
        // (Giữ nguyên logic getDuplicateBooking của Mobile)
        return _.find(unpaidBookings, b => {
            let isVerifyFlight = b.orderplanebookings.length === booking.Bookings.length;
            if (isVerifyFlight) {
                _.forEach(b.orderplanebookings, (item, index) => {
                    const flightInfo = chooseFlight[index]?.options[0]?.flights[0];
                    if (item.fromairport !== flightInfo?.startpoint || item.toairport !== flightInfo?.endpoint || item.airline !== chooseFlight[index]?.airline.code) isVerifyFlight = false;
                });
            }
            const isSamePassager = _.every(booking.Bookings[0].Passengers, p1 =>
                _.some(b.orderplanepassengers, p2 => p2.surname === p1.SurName && p2.givenname === p1.GivenName)
            );
            return b.fullnamecontact === booking.ContactFullName && b.emailcontact === booking.ContactEmail && isVerifyFlight && isSamePassager;
        });
    };

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const dataVerify = await verifyFlight();
            if (dataVerify.verifySession.length !== chooseFlight.length) {
                modal.confirm({ title: "Lỗi", content: "Chuyến bay đã đổi giá!", onOk: () => window.location.href = "/vemaybay" }); return;
            }

            const body = {
                ContactEmail: values.email, ContactPhone: values.phone, ContactFullName: `${values.surnameContact} ${values.lastNameContact}`,
                ContactGender: values.genderContact === "male", Amount: totalListPrice.totalDisplay,
                AmountOriginal: totalListPrice.totalDisplay + voucherValue, VoucherCode: voucherCode || "",
                AmountOtherIpass: totalListPrice.totalpriceAdd, Recovery: chooseFlight.length > 1 ? 1 : 0, TypeFlight: FlightType,
                Bookings: chooseFlight.map((flight, index) => {
                    const fInfo = flight?.options?.[0]?.flights?.[0];
                    return {
                        System: flight?.airline?.code, TypeFlight: FlightType, BookType: "normal",
                        VerifySession: _.find(dataVerify.verifySession, { startpoint: fInfo.startpoint })?.value || null,
                        flightvalues: [_.find(dataVerify.flightvalues, { startpoint: fInfo.startpoint })?.value || fInfo.flightvalue],
                        AutoIssue: FlightType === "domestic" && flight.isSameDayTicket,
                        StartDate: fInfo.startdate, EndDate: fInfo.enddate,
                        FlightValuesSearch: [fInfo.flightvalue],
                        Passengers: getPassengers(values, index), Airline: flight?.airline?.code,
                        FareClass: fInfo.segments?.[0]?.fareclass,
                        StartPoint: flight?.options?.[0]?.flights?.[0].startpoint,
                        EndPoint: flight?.options?.[0]?.flights?.[0].endpoint,
                    };
                }),
            };
            if (invoice) { body.VatMst = values.taxCode; body.VatFullName = values.receiverReceive; body.VatEmail = values.email; };

            setBodyBooking(body);
            const dupBooking = getDuplicateBooking(body);
            if (dupBooking) { setDataRepayment(dupBooking); setOpenRepaymentModal(true); }
            else setIsModalConfirm(true);

        } catch (error) {
            if (error?.message === "Lỗi xác thực chuyến bay") { notification.error({ message: "Lỗi", description: "Vui lòng chọn lại chuyến bay" }); return; }
            notification.error({ message: "Lỗi", description: error?.response?.data?.message || "Đã xảy ra lỗi" });
        } finally { setLoading(false); }
    };

    const handlePayment = async () => {
        setLoading(true);
        try {
            bodyBooking.ReturnUrl = window.location.origin + "/vemaybay";
            onChangeBookingInfo({ ...bodyBooking, totalListPrice });
            const res = await $axios.$post("/honghatrip/wallet-payment/VTCPAY", bodyBooking);
            if (res.data.statuscode === 200) {
                onChangeBookingInfo({ ...bodyBooking, totalListPrice, orderId: res?.data?.data?.ordercode, paymentUrl: res?.data?.data?.urlpayment });
                onChangeStep(4);
            } else { notification.error({ message: "Lỗi thanh toán" }); }
        } catch (err) { notification.error({ message: "Lỗi thanh toán", description: err?.response?.data?.message }); }
        finally { setLoading(false); }
    };

    // ----- UI RENDER -----
    return (
        <div className="desktop-step3-container" style={{ background: '#f0f4f8', minHeight: '100vh', fontFamily: "'Inter', sans-serif" }}>
            {contextHolder}

            {/* HEADER */}
            <header style={{
                background: 'linear-gradient(135deg, #0f172a, #1e3a5f)', color: 'white',
                padding: '16px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                position: 'sticky', top: 0, zIndex: 50,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}><img src={process.env.PUBLIC_URL + '/images/logo_ufone.png'} alt="Ufone" style={{ height: '36px' }} /></div>
                    <div style={{ width: '1px', height: '24px', background: 'rgba(255,255,255,0.2)' }} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ background: 'rgba(255,255,255,0.15)', padding: '4px 12px', borderRadius: '20px', fontSize: '13px' }}>Bước 3/5</span>
                        <span style={{ fontSize: '15px', fontWeight: 600 }}>Thông tin hành khách</span>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px', fontSize: '14px' }}>
                    {chooseFlight.map((f, idx) => (
                        <span key={idx} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ opacity: 0.7 }}>{idx === 0 ? '✈ Chiều đi:' : '✈ Chiều về:'}</span>
                            <span style={{ fontWeight: 700 }}>{f.options?.[0]?.flights?.[0]?.startpoint} → {f.options?.[0]?.flights?.[0]?.endpoint}</span>
                        </span>
                    ))}
                </div>
            </header>

            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '32px 24px', display: 'grid', gridTemplateColumns: '1fr 380px', gap: '28px' }}>

                {/* LEFT COLUMN - Form */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: 'white', padding: '16px 20px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
                        <Button onClick={() => {
                            if (tripType === "oneWay") {
                                setChoosingStep(1);
                                setChooseFlight([]);
                            } else {
                                setChoosingStep(2);
                                if (chooseFlight.length > 0) setChooseFlight([chooseFlight[0]]);
                                else setChooseFlight([]);
                            }
                            onChangeStep(2);
                        }} shape="circle" icon={<svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" /></svg>} />
                        <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0, color: '#1e293b' }}>Điền thông tin hành khách</h2>
                    </div>

                    <Form form={form} layout="vertical" onFinish={handleFinish} onValuesChange={handleValuesFormChange} initialValues={initialValues}>

                        {ListPassenger.map((p, index) => (
                            <div key={p.id} style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '24px', marginBottom: '20px' }}>
                                <h3 style={{ fontWeight: 700, fontSize: '17px', color: '#1d4ed8', marginBottom: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span>Hành khách {p.Index} <Tag color="blue" style={{ marginLeft: '8px', textTransform: 'uppercase' }}>{p.Type === 'ADT' ? 'Người lớn' : (p.Type === 'CHD' ? 'Trẻ em' : 'Em bé')}</Tag></span>
                                    {index === 0 && (
                                        <Radio.Group value={passengerIdChoose} onChange={(e) => setPassengerIdChoose(e.target.value)}>
                                            <Radio value={p.id}>Dùng làm liên hệ</Radio>
                                        </Radio.Group>
                                    )}
                                </h3>

                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                                    <Form.Item name={`surname_${p.id}`} label="Họ (Ví dụ: NGUYEN)" rules={[{ required: true, message: "Vui lòng nhập Họ!" }]}>
                                        <Input placeholder="Vd: NGUYEN" onChange={(e) => handleInputChange(e, `surname_${p.id}`)} />
                                    </Form.Item>
                                    <Form.Item name={`lastName_${p.id}`} label="Tên Đệm & Tên (Ví dụ: VAN A)" rules={[{ required: true, message: "Vui lòng nhập Tên!" }]}>
                                        <Input placeholder="Vd: VAN A" onChange={(e) => handleInputChange(e, `lastName_${p.id}`)} />
                                    </Form.Item>
                                    <Form.Item name={`gender_${p.id}`} label="Giới tính" rules={[{ required: true, message: "Chọn giới tính" }]}>
                                        <Radio.Group style={{ display: 'flex', width: '100%', marginTop: '4px' }}>
                                            <Radio value="male" style={{ flex: 1 }}>Nam</Radio>
                                            <Radio value="female" style={{ flex: 1 }}>Nữ</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                                    {p.Type !== "ADT" && (
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <Form.Item name={`day_${p.id}`} label="Ngày" style={{ width: '33%' }} rules={[{ required: true, message: "Ngày" }]}>
                                                <Select placeholder="Ngày" onChange={() => validateAndResetYearIfInvalid(p)} allowClear>
                                                    {getDays().map((d) => <Option key={d} value={d}>{d}</Option>)}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name={`month_${p.id}`} label="Tháng" style={{ width: '33%' }} rules={[{ required: true, message: "Tháng" }]}>
                                                <Select placeholder="Tháng" onChange={() => validateAndResetYearIfInvalid(p)} allowClear>
                                                    {getMonths().map((d) => <Option key={d} value={d}>{d}</Option>)}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name={`year_${p.id}`} label="Năm" style={{ width: '33%' }} rules={[{ required: true, message: "Năm" }]}>
                                                <Select placeholder="Năm" allowClear>
                                                    {getValidYearsByDayMonth(p.Type, form.getFieldValue(`day_${p.id}`), form.getFieldValue(`month_${p.id}`)).map((year) => (
                                                        <Option key={year} value={year}>{year}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    )}

                                    <Form.Item name={`baggage_${p.id}`} label={`Hành lý chiều đi (${chooseFlight[0]?.airline?.code})`} style={{ flex: 1 }}>
                                        <Select placeholder="Chọn hành lý mua thêm" allowClear style={{ width: '100%' }}>
                                            <Option key={-1} value={-1}>Chọn hành lý ký gửi</Option>
                                            {baggages.map((b) => <Option key={b.code} value={b.code}>{b.name} ({(b?.prices?.[0]?.price || b?.prices?.[0]?.value || 0).toLocaleString("vi-VN")}{b?.prices?.[0]?.currency || 'đ'})</Option>)}
                                        </Select>
                                    </Form.Item>

                                    {chooseFlight.length > 1 && (
                                        <Form.Item name={`baggage_out_${p.id}`} label={`Hành lý chiều về (${chooseFlight[1]?.airline?.code})`} style={{ flex: 1 }}>
                                            <Select placeholder="Chọn hành lý mua thêm" allowClear style={{ width: '100%' }}>
                                                <Option key={-1} value={-1}>Chọn hành lý ký gửi</Option>
                                                {baggagesOut.map((b) => <Option key={b.code} value={b.code}>{b.name} ({(b?.prices?.[0]?.price || b?.prices?.[0]?.value || 0).toLocaleString("vi-VN")}{b?.prices?.[0]?.currency || 'đ'})</Option>)}
                                            </Select>
                                        </Form.Item>
                                    )}
                                </div>
                            </div>
                        ))
                        }

                        {/* CONTACT INFO */}
                        <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '24px', marginBottom: '20px' }}>
                            <h3 style={{ fontWeight: 700, fontSize: '17px', color: '#1d4ed8', marginBottom: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>Thông tin liên hệ</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                                <Form.Item name="surnameContact" label="Họ Liên Hệ" rules={[{ required: true, message: "Bắt buộc!" }]}>
                                    <Input onChange={(e) => handleInputChange(e, 'surnameContact')} />
                                </Form.Item>
                                <Form.Item name="lastNameContact" label="Tên Liên Hệ" rules={[{ required: true, message: "Bắt buộc!" }]}>
                                    <Input onChange={(e) => handleInputChange(e, 'lastNameContact')} />
                                </Form.Item>
                                <Form.Item name="phone" label="Số điện thoại" rules={[{ required: true, message: "Bắt buộc!" }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="email" label="Email nhận vé" rules={[{ required: true, message: "Bắt buộc!", type: 'email' }]}>
                                    <Input />
                                </Form.Item>
                            </div>
                        </div>

                        {/* INVOICE */}
                        <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '24px', marginBottom: '20px' }}>
                            <Form.Item name="invoice" valuePropName="checked" style={{ marginBottom: 0 }}>
                                <Checkbox style={{ fontWeight: 700, fontSize: '16px' }}>Bạn có muốn lấy hóa đơn/ VAT không?</Checkbox>
                            </Form.Item>
                            {invoice && (
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginTop: '16px', background: '#f8fafc', padding: '16px', borderRadius: '10px' }}>
                                    <Form.Item name="taxCode" label="Mã số thuế" rules={[{ required: true, message: 'Bắt buộc!' }]}><Input /></Form.Item>
                                    <Form.Item name="companyName" label="Tên công ty" rules={[{ required: true, message: 'Bắt buộc!' }]}><Input /></Form.Item>
                                    <Form.Item name="companyAddress" label="Địa chỉ công ty" rules={[{ required: true, message: 'Bắt buộc!' }]}><Input /></Form.Item>
                                    <Form.Item name="receiverReceive" label="Người nhận HĐ" rules={[{ required: true, message: 'Bắt buộc!' }]}><Input /></Form.Item>
                                </div>
                            )}
                        </div>

                        {/* BUTTONS */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <Button size="large" onClick={() => onChangeStep(2)} style={{ borderRadius: '10px', borderColor: '#e2e8f0' }}>Quay lại</Button>
                            <Button type="primary" htmlType="submit" size="large" style={{ background: 'linear-gradient(135deg, #f97316, #ea580c)', border: 'none', fontWeight: 700, padding: '0 32px', borderRadius: '10px', boxShadow: '0 4px 14px rgba(249,115,22,0.35)' }}>
                                TIẾP TỤC ĐẾN THANH TOÁN
                            </Button>
                        </div>
                    </Form >
                </div >

                {/* RIGHT COLUMN - Summary */}
                < div style={{ display: 'flex', flexDirection: 'column', gap: '16px', position: 'sticky', top: '24px', height: 'fit-content' }}>
                    {
                        chooseFlight.map((f, idx) => (
                            <div key={idx} style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '20px' }}>
                                <h3 style={{ fontWeight: 700, color: '#1d4ed8', marginBottom: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '15px' }}>
                                    {idx === 0 ? "Chuyến đi" : "Chuyến về"}
                                    <img style={{ height: '18px', objectFit: 'contain' }} src={`${process.env.REACT_APP_BASE_URL}/${f.airline.iconurl}`} alt="" />
                                </h3>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '20px', fontWeight: 700 }}>{formatTime(f.options[0].flights[0].startdate)}</div>
                                        <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 700, background: '#f1f5f9', padding: '1px 8px', borderRadius: '4px', marginTop: '4px' }}>{f.options[0].flights[0].startpoint}</div>
                                    </div>
                                    <div style={{ flex: 1, padding: '0 12px', textAlign: 'center', fontSize: '12px', color: '#94a3b8' }}>
                                        <div style={{ width: '100%', height: '1px', background: '#cbd5e1', position: 'relative', margin: '4px 0' }}>
                                            <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', padding: '0 4px' }}>✈</span>
                                        </div>
                                        {calculateTimeDifference(f.options[0].flights[0].startdate, f.options[0].flights[0].enddate)}
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '20px', fontWeight: 700 }}>{formatTime(f.options[0].flights[0].enddate)}</div>
                                        <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 700, background: '#f1f5f9', padding: '1px 8px', borderRadius: '4px', marginTop: '4px' }}>{f.options[0].flights[0].endpoint}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                    {/* PRICE SUMMARY */}
                    <div style={{ background: 'linear-gradient(160deg, #1e3a5f, #0f172a)', borderRadius: '16px', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', padding: '20px', color: 'white' }}>
                        <h3 style={{ color: 'white', fontWeight: 700, fontSize: '16px', marginBottom: '16px', textAlign: 'center', borderBottom: '1px solid rgba(255,255,255,0.15)', paddingBottom: '12px' }}>TÓM TẮT ĐƠN HÀNG</h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>Vé máy bay ({chooseFlight.length} chuyến)</span>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '14px' }}>{formatNumberWithDots(totalListPrice.totalFixed)} đ</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>Hành lý mua thêm</span>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '14px' }}>{formatNumberWithDots(totalListPrice.baggage + totalListPrice.baggage_out)} đ</span>
                        </div>
                        {voucherValue > 0 && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', color: '#86efac' }}>
                                <span>Mã giảm giá ({voucherCode})</span>
                                <span style={{ fontWeight: 700 }}>- {formatNumberWithDots(voucherValue)} đ</span>
                            </div>
                        )}
                        <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px' }}>TỔNG TIỀN</span>
                                <span style={{ fontWeight: 800, fontSize: '26px', color: '#fb923c' }}>{formatNumberWithDots(totalListPrice.totalDisplay)}<span style={{ fontSize: '16px' }}>đ</span></span>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <ConfirmModal
                visible={isModalConfirm}
                onClose={() => setIsModalConfirm(false)}
                onOk={handlePayment}
                data={bodyBooking}
            />

            {
                openRepaymentModal && dataRepayment && (
                    <RepaymentModal
                        isOpen={openRepaymentModal}
                        onClose={() => { setOpenRepaymentModal(false); setDataRepayment(null); }}
                        history={dataRepayment}
                        bodyBooking={bodyBooking}
                        onChangeBookingInfo={onChangeBookingInfo}
                    />
                )
            }
        </div >
    );
};

export default DesktopStep3;
